import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons/faArrowRotateRight';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faReceipt } from '@fortawesome/pro-light-svg-icons/faReceipt';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import Header from 'components/Checkout2/UI/Header';
import { FunctionComponent } from 'react';
import { ToolbarButton, ToolbarOption } from './UI/ToolbarButton';
import PaidTag from './PaidTag';
import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from '@emotion/react';

export interface OrderDetailHeaderProps {
    title: string;
    loading?: boolean;
    editing?: boolean;
    paid?: boolean;
    orderClosed?: boolean;
    withoutOptions?: boolean;
    allPetsInactive?: boolean;
    onlyOnePet?: boolean;
    onClose?: () => void;
    onBack?: () => void;
    onEdit: () => void;
    onRebook: () => void;
    onShowLog: () => void;
    onDelete?: () => void;
    onShowInvoice?: () => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paidTag: {
            marginRight: 10
        }
    })
);

export const OrderDetailHeader: FunctionComponent<OrderDetailHeaderProps> = props => {
    const classes = useStyles();

    const toolbarOptions: Array<ToolbarOption> = [
        {
            id: 'invoice',
            icon: faReceipt,
            label: 'View Invoice',
            onClick: () => !props.loading && props.onShowInvoice && props.onShowInvoice()
        },
        {
            id: 'edit',
            icon: faPencil,
            label: 'Edit Booking',
            onClick: () => !props.loading && props.onEdit()
        },
        {
            id: 'rebook',
            icon: faArrowRotateRight,
            label: 'Rebook',
            onClick: () => !props.loading && props.onRebook()
        }
        /*{
            id: 'log',
            icon: faClockRotateLeft,
            label: 'Activity Log',
            onClick: () => !props.loading && props.onShowLog()
        },*/
        /*{
            id: 'delete',
            icon: faTrashAlt,
            label: 'Delete',
            color: '#EF4F57',
            onClick: () => !props.loading && props.onDelete && props.onDelete()
        }*/
    ]
        .filter(option => props.onDelete || option.id !== 'delete')
        .filter(option => !props.onlyOnePet || option.id !== 'edit')
        .filter(option => !props.orderClosed || ['rebook', 'log', 'invoice'].includes(option.id))
        .filter(option => !props.allPetsInactive || option.id !== 'rebook')
        .filter(option => props.paid || option.id !== 'invoice');

    return (
        <Header {...props}>
            {props.editing || props.loading || props.withoutOptions ? null : (
                <>
                    {props.paid && <PaidTag className={classes.paidTag} />}
                    {toolbarOptions.length > 0 && <ToolbarButton options={toolbarOptions} />}
                </>
            )}
        </Header>
    );
};

export default OrderDetailHeader;
